// extracted by mini-css-extract-plugin
export default {"form":"FormFiles_form__GKJug"};